(function () {
    'use strict';

    angular
        .module('Lavpop-store.services')
        .service('NotifyService', NotifyService)

    /** @ngInject */
    function NotifyService(ngNotify) {
        const NotifyService = {
            success: success,
            warning: warning,
            error: error
        };

        ngNotify.config({
            theme: 'pure',
            position: 'top',
            duration: 5000,
            html: false
        });

        return NotifyService;

        function success(message = 'Registro salvo com sucesso') {
            ngNotify.set(message, 'success');
        }

        function error(message = 'Ops, Ocorreu algum erro ao executar essa ação') {
            ngNotify.set(message, 'error');
        }

        function warning(message = 'Ops') {
            ngNotify.set(message, 'warning');
        }
    }
}());